export default "__VITE_ASSET__Dx8RpXbc__"